/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {
	AfterViewInit,
	ChangeDetectorRef,
	Component,
	ComponentFactoryResolver,
	ComponentRef,
	EmbeddedViewRef,
	OnDestroy,
	TemplateRef,
	Type,
	ViewChild,
	ViewContainerRef
} from '@angular/core';
import { IDataModal } from '@pacifico/interfaces/components.interface';
import { Subject } from 'rxjs';
import { InsertionDirective } from './insertion.directive';
import { DialogRef } from './models/modal-ref';

@Component({
	selector: 'app-modal-lateral',
	templateUrl: './modal-lateral.component.html'
})
export class ModalLateralComponent implements AfterViewInit, OnDestroy {
	@ViewChild(InsertionDirective) insertionPoint!: InsertionDirective;

	private _componentRef!: ComponentRef<any>;
	private _embeddedViewRef!: EmbeddedViewRef<unknown>;
	private _viewContainerRef!: ViewContainerRef;

	title = '';
	titleStrong = '';
	className: string[] = [];
	private readonly _onClose = new Subject<unknown>();
	public onClose = this._onClose.asObservable();

	datamodal!: IDataModal;

	constructor(
		private componentFactoryResolver: ComponentFactoryResolver,
		private cd: ChangeDetectorRef,
		private dialogRef: DialogRef
	) {}

	ngAfterViewInit(): void {
		setTimeout(() => {
			this.loadChildComponent(this.datamodal);
			this.cd.detectChanges();
		}, 0);
	}

	overlayClicked(): void {
		this.dialogRef.close();
		this._destroy();
	}

	loadChildComponent(dataModal: IDataModal): void {
		const instanceTemplateRef = dataModal.component instanceof TemplateRef;
		const instanceType = dataModal.component instanceof Type;

		this._destroy();
		if (dataModal.title) {
			this.title = dataModal.title;
		}

		if (dataModal.titleStrong) {
			this.titleStrong = dataModal.titleStrong;
		}

		if (dataModal.classModal) {
			this.className = dataModal.classModal;
		}

		if (instanceType) {
			this._createComponent(dataModal);
		} else if (instanceTemplateRef) {
			this._createTemplate(dataModal);
		}
	}

	private _createTemplate(dataModal: IDataModal): void {
		const templateRef = dataModal.component as TemplateRef<unknown>;
		this._embeddedViewRef = this.insertionPoint.viewContainerRef.createEmbeddedView(templateRef);
	}

	private _createComponent(dataModal: IDataModal): void {
		const component = dataModal.component as Type<unknown>;
		const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);

		this._viewContainerRef = this.insertionPoint.viewContainerRef;

		this._componentRef = this._viewContainerRef.createComponent(componentFactory);
		if (dataModal.dataTransfer) {
			dataModal.dataTransfer.forEach((item) => {
				this._componentRef.instance[item.key] = item.value;
			});
		}
	}

	ngOnDestroy(): void {
		this._destroy();
	}

	private _destroy(): void {
		if (this._componentRef) {
			this._componentRef.destroy();
		}

		if (this._viewContainerRef) {
			this._viewContainerRef.clear();
		}

		if (this._embeddedViewRef) {
			this._embeddedViewRef.destroy();
			this.insertionPoint.viewContainerRef.clear();
		}
	}

	close(): void {
		this._onClose.next();
	}
}
